export function hasMemberAccess(publicMetadata: unknown): boolean {
  if (
    !publicMetadata ||
    typeof publicMetadata !== "object" ||
    Array.isArray(publicMetadata)
  ) {
    return false;
  }
  const products = (publicMetadata as { products?: unknown }).products;
  return Array.isArray(products) && products.includes("etp");
}
